import { AnimatePresence, motion} from 'framer-motion'


// css
import './css/slidecomponent.css'
import './css/slide3.css'

const Slide_3 = ({ counter }) => { 
	return(
		<AnimatePresence>
			{counter === 3 &&
			<motion.div 
				key="slide_components_1key0"
				initial={{opacity:0}}
				animate={{opacity:1}}
				transition={{duration:1}}
				exit={{opacity:0}}
				className="slide_components" id="slide_components_3" 
				>
				<i className="fas fa-flask bg-flash"></i>
				<b className="lab_title">Wellcome to my lab</b>	
				<p className="lab_desc">
					here i present all the new skills i am currently learning in defferent categories
					such as forntend, backend & databaeses.
				</p>
				<ul className="lab_list">
					<li>
						<b><i className="fas fa-flask"></i>Frontend</b>
						<ul>
							<li>Framer Motion</li>
						</ul>
					</li>

					<li>
						<b><i className="fas fa-flask"></i>Backend</b>
						<ul>
							<li>WebSocket</li>
							<li>Socket.io</li>
						</ul>
					</li>

					<li>
						<b><i className="fas fa-flask"></i>Database</b>
						<ul>
							<li>Redis</li>
						</ul>
					</li>
				</ul>
			</motion.div>
			}
		</AnimatePresence>
		)
}

export default Slide_3